import { useOverlays } from "contexts/OverlayContext";
import { InvoiceTemplatesDrilldownDrawer } from "./InvoiceTemplatesDrilldownDrawer";

export const GlobalInvoiceTemplatesDrilldownDrawer: React.FC = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo("invoiceTemplatesDrilldown");

    if (!overlayInfo?.data) {
        return null;
    }

    return (
        <InvoiceTemplatesDrilldownDrawer
            open={!overlayIsClosing}
            onClose={closeOverlay}
            catalogItemIds={overlayInfo.data.catalogItemIds}
        />
    );
};
